module.exports = __webpack_public_path__ + "img/germany-liver-cancer-male.d0af7821.png";